import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@blueprintjs/core';
import { ShowHide } from 'components/layout';
import 'components/notifications/Notifications.css';

const spinnerSize = 50;

export function RedirectPanel(
    {
        heading = 'Just a moment',
        message = 'Please wait while we take you to the right place.'
    }
) {
    return (
        <div className="notification-panel">
            <ShowHide
                evaluator={heading != null}
                show={(<h2>{heading}</h2>)}
            />
            <ShowHide
                evaluator={message != null}
                show={(<p>{message}</p>)}
            />
            <div className="spacer-top">
                <Spinner size={spinnerSize} />
            </div>
        </div>
    );
}

RedirectPanel.propTypes = {
    heading: PropTypes.node,
    message: PropTypes.node
};
